import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useRef
} from 'react';
import { FiChevronDown, FiChevronRight } from 'react-icons/fi';
import { useParams, useHistory } from 'react-router-dom';
import { ErrorMessage } from '@hookform/error-message';
import { useForm, Controller } from 'react-hook-form';
import SelectContact from 'react-select/creatable';
import { FiEdit, FiPlus } from 'react-icons/fi';
import Select from 'react-select/async';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import {
  Row,
  Form,
  Card,
  CardBody,
  CardHeader,
  Col,
  Input,
  Container,
  Button,
  ButtonGroup
} from 'reactstrap';

import { useEntityCustomFieldsByRecordType } from 'views/fieldConfigs/hooks/useCustomFieldsByRecordType';
import { formatCustomFieldsToDisplay } from 'views/CRM/shared/helpers/customFieldsHelpers';
import { formatCustomFieldsToSubmit } from 'views/CRM/shared/helpers/customFieldsHelpers';
import { useGetLostReasonByEntity } from '../../../../hooks/useGetLostReasonByEntity';
import { custom_select } from '../../../../../../assets/styles/multiple_select';
import { Attachments } from '../../../../shared/components/UploadAttachments';
import { maskPhoneNumber } from 'views/CRM/shared/utils/phoneNumberHelpers';
import { getContactsAttempts } from 'views/CRM/shared/ContactAttempt/utils';
import { useSearchAccounts } from '../../../hooks/useSearchAccounts';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import { toBrazilianFullDate } from 'views/CRM/shared/utils/date';
import { toBrazilianDate } from 'views/CRM/shared/utils/date';

import ContactAttemptTimelineModal from 'views/CRM/shared/ContactAttempt/components/ContactTimeLineModal';
import ModalSchedulingProtocol from '../../../../../../views/CRM/Scheduling/ModalScheduling/index';
import SchedulingCrmService from '../../../../../../views/CRM/Lead/services/scheduleCrmService';
import CatalogProductsForm from '../../../../PriceCatalog/externalForm/CatalogProductsForm';
import CustomFieldsInputsForm from '../../../../shared/components/CustomFieldsInputsForm';
import ListSchedules from '../../../../../../views/CRM/Scheduling/SchedulesList/index';
import OpportunityStageService from '../../../../OpportunityStages/service';
import ClientService from '../../../../../../views/Clients/service/index';
import OpportunityService from '../../../services/opportunityService';
import ChangeResponsibleModal from '../ChangeResponsibleModal';
import RecordTypeService from '../../../../../RecordType/service';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import ConversionModal from '../ConversionOpportunityModal';
import ShowHistoryChanges from 'components/HistoryChanges';
import CurrencyMask from 'components/Inputs/CurrencyMask';
import ModalComment from '../Comments/ModalUpdateComment';
import ReactButton from 'components/Buttons/ReactButton';
import DatePicker from 'components/Inputs/DatePicker.js';
import ModalLostReason from '../ModalLostReason/index';
import OpportunityTimeModal from '../OpportunityTime';
import ListComments from '../Comments/CommentsList';
import CommentModal from '../Comments/CommentsForm';
import Loader from 'components/Loader';
import OpportunityTemperature from '../../../../../../components/OpportunityTemperature';
import './styles.css';
import AddAccountModal from '../../../../Contact/form/AddAccountModal';
import EditAccountModal from '../../../../Contact/form/EditAccountModal/EditAccountModal';
import EditContactModal from 'views/CRM/Account/form/EditContactModal/EditContactModal';
import ModalFilterClients from 'views/Clients/components/ModalFilterClients';
import { SearchContactButton } from 'components/Buttons/SearchContactButton';
import { AddNewContactButton } from 'components/Buttons/AddNewContactButton';
import AccountService from '../../../../Account/services/accountService';
import AddContactModal from 'views/Protocol/form/components/AddContactModal';
import contactService from 'views/CRM/Contact/services/contactService';
import { Separator } from 'components/Separator';
import AddAddressModal from 'components/AddAddressModal';
import OpportunityAddress from '../OpportunityAddress';
import ConversationDetails from 'components/Conversation/ConversationDetails';

const CustomFieldsFilterToggle = styled.div`
  display: inline-block;
  margin-bottom: 1rem;
  user-select: none;
  :hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

const OpportunityEdit = () => {
  const { control, reset, setValue, handleSubmit, errors, watch, getValues } =
    useForm();
  const { recordTypeId, id } = useParams();
  const history = useHistory();
  const catalogFormRef = useRef(null);
  const shouldGeneratePDFAfterUpdate = useRef(false);

  const [opportunity, setOpportunity] = useState();
  const stageId = opportunity?.stageId;
  const [availableStages, setAvailableStages] = useState([]);
  const [listSchedules, setListSchedules] = useState([]);
  const [isCurrentResponsible, setIsCurrentResponsible] = useState('');
  const [isSchedulingModalOpen, setIsSchedulingModalOpen] = useState(false);
  const [isToUpdateScheduling, setIsToUpdateScheduling] = useState(false);
  const [isToCreateScheduling, setIsToCreateScheduling] = useState(false);
  const [schedulingId, setschedulingId] = useState();

  const [activeStage, setActiveStage] = useState();
  const [opportunityStages, setOpportunityStages] = useState();
  const [openModalLostReason, setOpenModalLostReason] = useState(false);
  const [isClientSearchModalOpen, setIsClientSearchModalOpen] = useState(false);
  const [isAccountSearchModalOpen, setIsAccountSearchModalOpen] =
    useState(false);
  const [isEditAccountModalOpen, setIsEditAccountModalOpen] = useState(false);
  const [isEditContactModalOpen, setIsEditContactModalOpen] = useState(false);
  const [accountResponse, setAccountResponse] = useState({});
  const [contactResponse, setContactResponse] = useState({});

  const currentOpportunityStage = useMemo(() => {
    if (!stageId || !opportunityStages) return undefined;

    const opportunityStage = opportunityStages.find(
      (item) => item.id === stageId
    );

    return opportunityStage;
  }, [stageId, opportunityStages]);

  const { getCustomFields, customFields, isLoadingCustomFields } =
    useEntityCustomFieldsByRecordType(entitiesName.OPPORTUNITY, recordTypeId);

  const filteredCustomFields = useMemo(() => {
    if (!currentOpportunityStage) return customFields;
    const filtered = customFields.filter((field) =>
      currentOpportunityStage?.fieldsDisplay?.includes(field.id)
    );

    filtered.forEach((element) => {
      if (currentOpportunityStage?.fieldsBlocked?.includes(element.id)) {
        element.blocked = true;
      }

      if (currentOpportunityStage?.fieldsRequired?.includes(element.id)) {
        element.required = true;
      }
    });

    return filtered;
  }, [customFields, currentOpportunityStage]);

  useEffect(() => {
    if (
      shouldGeneratePDFAfterUpdate.current &&
      currentOpportunityStage?.proposalId &&
      catalogFormRef.current
    ) {
      catalogFormRef.current.generatePDF();
      shouldGeneratePDFAfterUpdate.current = false;
    }
  }, [currentOpportunityStage]);

  const [changedStage, setChangedStage] = useState(false);
  const { isSearching, filterAccounts } = useSearchAccounts();
  const [account, setAccount] = useState();
  const [isChangeReponsibleModalOpen, setIsChangeReponsibleModalOpen] =
    useState(false);
  const [listComments, setListComments] = useState([]);
  const [openConversionOpportunityModal, setOpenConversionOpportunityModal] =
    useState(false);
  const [openModalCreateComment, setOpenModalCreateComment] = useState(false);
  const [openModalOpportunityTime, setOpenModalOpportunityTime] =
    useState(false);
  const [dataCommentUpdate, setDataCommentUpdate] = useState([]);
  const [openModalUpdateComment, setOpenModalUpdateComment] = useState(false);
  const [chatCreatedOnIsolatedMessageId, setChatCreatedOnIsolatedMessageId] =
    useState(null);

  const [callUniqueId, setCallUniqueId] = useState(null);
  const [
    isContactAttemptTimelineModalOpen,
    setIsContactAttemptTimelineModalOpen
  ] = useState(false);
  const [isToChangeStage, setIsToChangeStage] = useState(true);

  const [openModalReason, setOpenModalReason] = useState(false);
  const [updateLostReason, setUpdateLostReason] = useState({});
  const [isEditLostReason, setIsEditLostReason] = useState(false);

  const { listLostReason } = useGetLostReasonByEntity({
    entity: entitiesName.OPPORTUNITY,
    recordTypeId
  });

  const [clientToSelect, setClientsToSelect] = useState([]);
  const [selectedClient, setSelectClient] = useState('');
  const [timeoutID, setTimeoutID] = useState(null);
  const [clientNewData, setClientNewData] = useState(null);
  const [recordType, setRecordType] = useState(null);
  const [opportunityCatalogChangeHistory, setLeadCatalogChangeHistory] =
    useState([]);
  const [opportunityCatalog, setOpportunityCatalog] = useState(null);
  const [opportunityAddresses, setOpportunityAddresses] = useState([]);
  const [opportunityConversations, setOpportunityConversations] = useState([]);

  const getAccount = async (recordTypeId, id) => {
    await AccountService.getById(recordTypeId, id)
      .then((response) => {
        setAccountResponse(response?.data?.data);
      })
      .catch(() => {
        toast.error('Ocorreu um erro ao buscar informações da conta');
      });
  };

  const getContact = async (id) => {
    await contactService
      .getContactById(id)
      .then((response) => {
        setContactResponse(response?.data?.data);
      })
      .catch(() => {
        toast.error('Ocorreu um erro ao buscar informações da conta');
      });
  };

  const handleEditAccount = async () => {
    if (account && account.value) {
      try {
        await getAccount(account?.recordTypeId, account?.value);
        setIsEditAccountModalOpen(true);
      } catch (error) {
        console.log(error);
        toast.error('Ocorreu um erro ao buscar informações da conta');
      }
    } else {
      toast.error('Nenhuma conta selecionada ou recordTypeId inválido');
    }
  };

  const handleEditContact = async () => {
    if (selectedClient && selectedClient.value) {
      try {
        await getContact(selectedClient?.value);
        setIsEditContactModalOpen(true);
      } catch (error) {
        console.log(error);
        toast.error('Ocorreu um erro ao buscar informações da conta');
      }
    } else {
      toast.error('Nenhuma conta selecionada ou recordTypeId inválido');
    }
  };

  const alterDefaultModalData = useCallback(
    ({ clientId, clientName }) => {
      setClientSelected({
        value: clientId,
        label: clientName
      });
      setIsClientSearchModalOpen(false);
    },
    [setValue, reset]
  );

  useEffect(() => {
    if (recordTypeId) {
      RecordTypeService.get(recordTypeId)
        .then((res) => {
          const recordTypeData = res.data.content.disable_link_to_product;
          setRecordType(recordTypeData);
        })
        .catch((error) => {
          const errorMsg = error.response?.data?.message;
          toast.error(errorMsg || 'Erro ao buscar tipo de registro');
        });
    }
  }, [recordTypeId]);

  useEffect(() => {
    if (chatCreatedOnIsolatedMessageId) {
      getContactsAttempts(
        chatCreatedOnIsolatedMessageId,
        'CHAT',
        'OPPORTUNITY',
        id
      );
    }

    if (callUniqueId) {
      getContactsAttempts(callUniqueId, 'TELEFONIA', 'OPPORTUNITY', id);
      return;
    }
  }, [callUniqueId, chatCreatedOnIsolatedMessageId, id]);

  const getOpportunityCatalogChangesHistory = useCallback(() => {
    const opportunityCatalogId = opportunity?.catalog?.id;
    OpportunityService.getOpportunityCatalogHistoryChanges(opportunityCatalogId)
      .then((response) => {
        setLeadCatalogChangeHistory(response.data.data);
      })
      .catch(() => {
        toast.error(
          'Ocorreu um erro ao buscar o histórico de alterações do catálogo da oportunidade'
        );
      });
  }, [opportunity]);

  const getOpportunityConversations = useCallback(() => {
    if (!id) return;

    OpportunityService.getConversationsByOpportunity(id)
      .then((res) => {
        setOpportunityConversations(res.data.conversas || res.data.data || []);
      })
      .catch((err) => {
        // Não exibe erro se não houver conversas associadas
        if (err?.response?.status !== 404) {
          console.error('Erro ao buscar conversas da oportunidade:', err);
        }
      });
  }, [id]);

  useEffect(() => {
    getCustomFields();
  }, [getCustomFields]);

  useEffect(() => {
    if (id && !isLoadingCustomFields) {
      getOpportunityById();
    }
  }, [id, getOpportunityById, isLoadingCustomFields]);

  useEffect(() => {
    OpportunityStageService.listOrdenade(recordTypeId)
      .then((res) => {
        setOpportunityStages(res.data.data);
      })
      .catch(() => {
        toast.error('Erro ao carregar as fases.', {
          closeOnClick: true,
          autoClose: 3000
        });
      });
  }, [recordTypeId]);

  useEffect(() => {
    if (!opportunity?.catalog) return;
    getOpportunityCatalogChangesHistory();
  }, [getOpportunityCatalogChangesHistory]);

  useEffect(() => {
    getOpportunityConversations();
  }, [getOpportunityConversations]);

  const handleGetClient = (value) => {
    if (value) {
      ClientService.getAllFilter('cliente', '', 'ALL', {
        nome: value,
        email: value
      })
        .then((response) => {
          const { content } = response.data;
          const sortClientsArray = sortData(content);
          const setData = sortClientsArray.map((client) => {
            const setClient = {
              email: client.email,
              telefone: client.telefone,
              label: client.nome,
              value: client.id
            };
            return setClient;
          });
          setClientsToSelect(setData);
        })
        .catch((err) => {
          const message =
            (err.response && err.response.data) || 'Erro ao carregar contatos';
          toast.error(message, {
            autoClose: 3000,
            closeOnClick: true
          });
        });
    } else {
      setClientsToSelect();
    }
  };

  const seachClientSelect = (value) => {
    if (typeof timeoutID === 'number') {
      clearTimeout(timeoutID);
    }
    setTimeoutID(
      setTimeout(() => {
        handleGetClient(value);
      }, 1200)
    );
  };

  const setClientSelected = (client) => {
    if (client) {
      setSelectClient({ value: client.value, label: client.label });
      setClientNewData(client);
      if (client.value) {
        getContact(client.value);
      }
    } else {
      setSelectClient();
      setClientNewData('');
      setContactResponse({});
    }
  };

  const sortData = (data) => {
    const dataSort = data.sort((a, b) => {
      if (a.name) {
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      } else {
        if (a.nome.toLowerCase() < b.nome.toLowerCase()) return -1;
        if (a.nome.toLowerCase() > b.nome.toLowerCase()) return 1;
        return 0;
      }
    });
    return dataSort;
  };

  const getCommnents = useCallback(() => {
    if (id) {
      OpportunityService.getOpportunityComments(id)
        .then((res) => {
          setListComments(res.data.data);
        })
        .catch((err) => {
          toast.error(
            'Houve um erro ao buscar os comentários dessa oportunidade',
            {
              closeOnClick: true,
              autoClose: 3000
            }
          );
          console.log(err);
        });
    }
  }, [id]);

  useEffect(getCommnents, [getCommnents]);

  const changeOpportunityStage = async (data) => {
    OpportunityService.updateStage(opportunity.id, data)
      .then(() => {
        setChangedStage(true);
        toast.success('Fase atualizada com sucesso.', {
          closeOnClick: true,
          autoClose: 3000
        });
        if (id && !isLoadingCustomFields) {
          const reload = getOpportunityById();
          if (reload && typeof reload.then === 'function') {
            reload.catch(() => {
              toast.warning(
                'Fase atualizada, mas houve um erro ao recarregar os dados. Atualize a página.',
                {
                  autoClose: 5000,
                  closeOnClick: true
                }
              );
            });
          }
        }
      })
      .catch((error) => {
        const message = error.response.data.message;
        toast.error(message || 'Erro ao atualizar a fase.', {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  };

  const updateStage = () => {
    const data = {
      stageId: activeStage
    };
    const newStage = opportunityStages.find(
      (stage) => stage.id === activeStage
    );

    if (
      newStage.type === 'CLOSED_LOST' &&
      listLostReason.length > 0 &&
      !opportunity?.lostReason
    ) {
      setOpenModalReason(true);
      setUpdateLostReason(data);
    } else {
      OpportunityService.updateStage(opportunity.id, data)
        .then(async () => {
          setChangedStage(true);
          toast.success('Fase atualizada com sucesso.', {
            closeOnClick: true,
            autoClose: 3000
          });

          shouldGeneratePDFAfterUpdate.current = true;

          if (id && !isLoadingCustomFields) {
            try {
              await getOpportunityById();
            } catch (e) {
              toast.warning(
                'Fase atualizada, mas houve um erro ao recarregar os dados. Atualize a página.',
                {
                  autoClose: 5000,
                  closeOnClick: true
                }
              );
            }
          }
        })
        .catch((error) => {
          const message = error.response.data.message;
          toast.error(message || 'Erro ao atualizar a fase.', {
            autoClose: 3000,
            closeOnClick: true
          });
        });
    }
  };

  const handleUpdateLostReason = async (data) => {
    if (data.isDeleted === true) {
      await OpportunityService.updateOpportunityLostReason(opportunity.id, data)
        .then(() => {
          toast.success('Motivo da Perda  deletado com sucesso.', {
            autoClose: 3000,
            closeOnClick: true
          });
          getOpportunityById();
          setIsEditLostReason(false);
        })
        .catch((error) => {
          const errMsg = error?.response?.data?.message;
          toast.error(errMsg || 'Não foi possível atualizar o Lead.', {
            autoClose: 3000,
            closeOnClick: true
          });
        });
    } else {
      await OpportunityService.updateOpportunityLostReason(opportunity.id, data)
        .then(() => {
          toast.success('Motivo da Perda  atualizado com sucesso.', {
            autoClose: 3000,
            closeOnClick: true
          });
          getOpportunityById();
          setIsEditLostReason(false);
        })
        .catch((error) => {
          const errMsg = error?.response?.data?.message;
          toast.error(errMsg || 'Não foi possível atualizar o Lead.', {
            autoClose: 3000,
            closeOnClick: true
          });
        });
    }
  };

  const reloadOpportunity = useCallback(() => {
    if (id) {
      OpportunityService.getOpportunityAddresses(id)
        .then((addressResponse) => {
          const addresses = addressResponse?.data?.data || [];
          setOpportunityAddresses(addresses);
        })
        .catch((error) => {
          console.error('Erro ao recarregar endereços:', error);
        });
    }
  }, [id]);

  const getOpportunityById = useCallback(() => {
    OpportunityService.getById(recordTypeId, id)
      .then(({ data }) => {
        setAvailableStages(data.data.stagesFree ?? []);

        setAccount({
          label: data.data?.accountName,
          value: data.data?.accountId,
          recordTypeId: data.data?.accountRecordTypeId
        });
        if (data.data?.contactId) {
          setSelectClient({
            label: data.data?.contactName || '',
            value: data.data?.contactId || ''
          });
        } else {
          setSelectClient();
        }

        const reqData = {
          ...data.data,
          phone: maskPhoneNumber(data.data.phone),
          expectedClosure: data.data.expectedClosure
            ? toBrazilianDate(data.data.expectedClosure)
            : null
        };

        const formattedData = formatCustomFieldsToDisplay(
          reqData,
          customFields
        );
        if (
          formattedData.amount !== undefined &&
          formattedData.amount !== null
        ) {
          formattedData.amount = parseFloat(formattedData.amount);
          formattedData.amount = formattedData.amount.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
        }
        if (
          opportunityStages?.filter(
            (stage) =>
              stage.id === formattedData.stageId && stage.type === 'CLOSED_WON'
          ).length > 0
        ) {
          setIsToChangeStage(!isToChangeStage);
        }
        setOpportunity(formattedData);
        setOpportunityCatalog(formattedData.catalog);
        setListSchedules(data.data.schedulingCrm);
        setIsCurrentResponsible(localStorage.getItem('login'));
        reset(formattedData);
        setActiveStage(formattedData.stageId);
        if (catalogFormRef.current) {
          catalogFormRef.current.forceUpdate();
        }

        reloadOpportunity();

        if (formattedData.accountId && formattedData.accountRecordTypeId) {
          getAccount(
            formattedData.accountRecordTypeId,
            formattedData.accountId
          ).catch((err) => {
            console.error('Erro ao buscar dados da conta:', err);
          });
        }
        if (formattedData.contactId) {
          getContact(formattedData.contactId).catch((err) => {
            console.error('Erro ao buscar dados do contato:', err);
          });
        }
      })
      .catch(() => {
        toast.error('Erro ao buscar dados da oportunidade');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    id,
    recordTypeId,
    customFields,
    setAvailableStages,
    availableStages,
    reloadOpportunity
  ]);

  const validationFieldRequired = async () => {
    const data = {
      stageId: activeStage
    };
    await OpportunityService.validateFieldRequired(
      id || opportunity.id,
      recordTypeId,
      data
    )
      .then(() => {
        setOpenConversionOpportunityModal(true);
      })
      .catch((error) => {
        const errMsg =
          error.response?.data?.message || 'Erro ao atualizar a fase.';
        toast.error(errMsg, {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  };

  const changeStage = (stage) => {
    setActiveStage(stage);
  };

  const changeResponsible = async () => {
    setIsChangeReponsibleModalOpen(true);
  };

  if (isLoadingCustomFields) {
    return (
      <Row className="justify-content-md-center">
        <Loader />
      </Row>
    );
  }

  const onSubmit = async (data) => {
    if (isEditLostReason === true) return [];

    if (data.amount) {
      data.amount = data.amount
        .replace('R$', '')
        .replace(/\./g, '')
        .replace(',', '.')
        .trim();
    }

    data.accountId = account && account.value ? Number(account.value) : null;

    if (selectedClient) {
      data.contactId = selectedClient?.value;
    }

    let dataToSubmit = data;
    if (!recordType && data.catalogId && catalogFormRef.current) {
      dataToSubmit = catalogFormRef.current.formatProductsAndCatalogsToShow({
        ...data
      });
    }

    const dataDTO = formatCustomFieldsToSubmit(dataToSubmit, customFields);

    OpportunityService.updateOpportunity(recordTypeId, id, dataDTO)
      .then(() => {
        toast.success('Oportunidade atualizada com sucesso.', {
          autoClose: 3000,
          closeOnClick: true
        });

        getOpportunityById();
      })
      .catch(() => {
        toast.error('Não foi possível atualizar a Oportunidade.', {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  };

  const cancelAction = () => {
    history.push('/admin/crm/opportunity', { recordTypeId });
  };

  const handleUpdateComment = (dataComment) => {
    setOpenModalUpdateComment(true);
    setDataCommentUpdate(dataComment);
  };

  const handleOpenOpportunityTime = () => {
    setOpenModalOpportunityTime(true);
  };

  const handleCreateComment = () => {
    setOpenModalCreateComment(true);
  };

  const openContactAttemptTimeline = async () => {
    setIsContactAttemptTimelineModalOpen(true);
  };

  const reloadComments = () => {
    OpportunityService.getOpportunityComments(id).then((res) => {
      setListComments(res.data.data);
    });
  };

  const handleEditLostReason = async () => {
    setIsEditLostReason(true);
    setOpenModalReason(true);
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  const isOpenClosed = opportunityStages?.filter(
    (stage) => stage.id === activeStage && stage.type === 'CLOSED_WON'
  );

  const cancelSchedule = (scheduleId) => {
    if (!window.confirm('Cancelar agendamento?')) {
      return;
    } else {
      SchedulingCrmService.cancelScheduleCrm(scheduleId)
        .then(() => {
          toast.success('Agendamento cancelado com sucesso', {
            autoClose: 3000,
            closeOnClick: true
          });
          getOpportunityById();
        })
        .catch((error) => {
          toast.error(
            error || 'Houve um erro ao tentar cancelar o agendamento.',
            {
              autoClose: 3000,
              closeOnClick: true
            }
          );
        });
    }
  };

  const handleUpdateSchedule = (dataSchedule) => {
    setIsSchedulingModalOpen(true);
    setIsToUpdateScheduling(true);
    setschedulingId(dataSchedule.id);
    setIsToCreateScheduling(false);
  };

  return (
    <>
      <SimpleHeader
        name="Opportunity edition"
        parentName="Opportunity"
        returnPath="/admin/crm/opportunity"
        navigatorState={{ recordTypeId }}
      />
      <ModalLostReason
        isModalOpen={openModalReason}
        onModalToggle={setOpenModalReason}
        recordTypeId={recordTypeId}
        listLostReason={listLostReason}
        changeOpportunityStage={changeOpportunityStage}
        updateLostReason={updateLostReason}
        getOpportunityById={getOpportunityById}
        handleUpdateLostReason={handleUpdateLostReason}
        isEdit={isEditLostReason}
        opportunity={opportunity}
      />
      <ModalFilterClients
        className="modal-lg"
        show={isClientSearchModalOpen}
        onModalToggle={setIsClientSearchModalOpen}
        setSelectedClient={(a) => {
          setClientSelected({
            value: a?.clientId,
            label: a?.clientName
          });
          setIsClientSearchModalOpen(false);
        }}
      />
      <EditContactModal
        isModalOpen={isEditContactModalOpen}
        onModalToggle={(isOpen) => {
          setIsEditContactModalOpen(isOpen);
          if (!isOpen && selectedClient?.value) {
            getContact(selectedClient.value);
          }
        }}
        contact={contactResponse}
        recordTypeId={contactResponse?.recordTypeId}
        setSelectedClient={(contactResponse) => {
          setClientSelected({
            value: contactResponse?.contactId,
            label: contactResponse?.contactName
          });
          if (contactResponse?.contactId) {
            getContact(contactResponse.contactId);
          }
        }}
      />
      <Container className="configuration-container mt--6" fluid>
        <Card>
          <CardHeader
            style={{
              display: 'flex',
              flexDirection: 'column',
              padding: '1rem'
            }}
          >
            <div
              style={{
                display: 'flex',
                overflowX: 'auto',
                overflowY: 'hidden',
                paddingBottom: '0.5rem',
                width: '100%',
                scrollbarWidth: 'thin',
                scrollbarColor: '#888 #f1f1f1'
              }}
              className="opportunity-stages-container"
            >
              {opportunityStages &&
                opportunityStages.map((stage) => (
                  <ButtonGroup
                    key={stage.id}
                    style={{ flex: 1, minWidth: 'max-content' }}
                  >
                    <Button
                      color={
                        activeStage === stage.id
                          ? 'primary'
                          : activeStage > stage.id
                          ? 'success'
                          : 'dark'
                      }
                      outline
                      disabled={!availableStages?.includes(stage.id)}
                      active={activeStage >= stage.id}
                      size="md"
                      type="button"
                      title="Fases da Oportunidade"
                      onClick={() => {
                        changeStage(stage.id);
                      }}
                      style={{
                        width: '100%',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {stage.name}
                      <li className="fas fa-arrow-right ml-2"></li>
                    </Button>
                  </ButtonGroup>
                ))}
              <Button
                color="primary"
                size="sm"
                disabled={!isToChangeStage}
                onClick={() => {
                  if (isOpenClosed?.length > 0) {
                    validationFieldRequired();
                  } else {
                    updateStage();
                  }
                }}
                style={{
                  marginLeft: '0.5rem',
                  flexShrink: 0,
                  minWidth: '150px'
                }}
                title={
                  isToChangeStage
                    ? 'Atualizar fase da oportunidade.'
                    : 'Oportunidades do tipo fechado ganho não podem ter sua fase atualizada.'
                }
              >
                <li className="fas fa-check"></li>
                Atualizar fase
              </Button>
            </div>
          </CardHeader>
          <CardBody>
            {opportunity && (
              <Row className="mb-3">
                <Col sm="2">
                  <h3 className="font-weight-bold small mb-0">Responsável:</h3>
                  <span className="d-flex align-items-center">
                    <span
                      id="responsible-edit-label"
                      onClick={changeResponsible}
                    >
                      {opportunity?.responsibleName}{' '}
                    </span>
                    <FiEdit
                      onClick={changeResponsible}
                      className="ml-2"
                      cursor="pointer"
                      textDecoration="underline"
                    />
                  </span>
                </Col>
                <Col sm="3">
                  <h3 className="font-weight-bold small mb-0">Criado em:</h3>
                  <span>{toBrazilianFullDate(opportunity?.createdAt)}</span>
                </Col>
                <Col sm="3">
                  <h3 className="font-weight-bold small mb-0">
                    Última modificação por:
                  </h3>
                  <span>{opportunity?.lastUpdatedByName}</span>
                </Col>
                <Col sm="2">
                  <h3 className="font-weight-bold small mb-0">
                    Última modificação em:
                  </h3>
                  <span>{toBrazilianFullDate(opportunity?.lastUpdatedAt)}</span>
                </Col>
                <Col
                  sm="2"
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <h3 className="font-weight-bold small mb-0">
                    Prazos da Oportunidade:
                  </h3>
                  <Button
                    color="info"
                    size="sm"
                    onClick={() => handleOpenOpportunityTime()}
                  >
                    <li className="fas fa-clock"></li>
                  </Button>
                </Col>
              </Row>
            )}
            <hr />
            {opportunity?.lostReason && opportunity?.lostReason !== '' && (
              <>
                <CustomFieldsFilterToggle
                  className="small"
                  onClick={() => setOpenModalLostReason(!openModalLostReason)}
                >
                  <strong>Motivo da Perda </strong>
                  {openModalLostReason ? (
                    <FiChevronDown size={18} />
                  ) : (
                    <FiChevronRight size={18} />
                  )}
                </CustomFieldsFilterToggle>

                {openModalLostReason && (
                  <div style={{ marginBottom: '10px' }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: '#E0F7FA',
                        borderRadius: '16px',
                        padding: '0.5rem 0.5rem',
                        fontSize: '14px'
                      }}
                    >
                      <span
                        style={{
                          flex: 1,
                          textAlign: 'left'
                        }}
                      >
                        <strong>{opportunity?.lostReason}</strong> -{' '}
                        {opportunity?.commentLostReason}
                      </span>
                      <FiEdit
                        onClick={handleEditLostReason}
                        cursor="pointer"
                        style={{
                          color: '#00695C',
                          marginLeft: '0.5rem'
                        }}
                      />
                    </div>
                  </div>
                )}
                <hr />
              </>
            )}

            <OpportunityTemperature
              initialTemperature={opportunity?.temperature}
              opportunityId={id}
              onChange={(temperature) => {
                setValue('temperature', temperature);
              }}
            />

            <Separator />

            <Form
              className="needs-validation"
              onSubmit={handleSubmit(onSubmit)}
            >
              <Row className="mb-3">
                <Col sm="3">
                  <label className="form-control-label text-capitalize">
                    Título*
                  </label>
                  <Controller
                    render={(props) => (
                      <Input
                        value={props.value}
                        onChange={props.onChange}
                        type="text"
                        placeholder="Título"
                      />
                    )}
                    control={control}
                    defaultValue=""
                    name="title"
                    rules={{
                      required: 'Campo obrigatório'
                    }}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="title"
                    render={({ message }) => errorFormMessage(message)}
                  />
                </Col>
                <Col sm="3">
                  <label className="form-control-label text-capitalize">
                    Conta
                  </label>
                  <div style={{ display: 'flex' }}>
                    <div style={{ flexGrow: 1 }}>
                      <Select
                        styles={custom_select}
                        placeholder="Busca rápida"
                        isClearable={true}
                        name="accountId"
                        isLoading={isSearching}
                        loadingMessage={() => 'Buscando...'}
                        noOptionsMessage={({ inputValue }) =>
                          !inputValue
                            ? 'Digite para pesquisar'
                            : 'Nenhum resultado encontrado'
                        }
                        loadOptions={async (inputValue) => {
                          const res = await filterAccounts(inputValue);
                          return (
                            res &&
                            res.map((account) => ({
                              label: account.name,
                              value: account.id,
                              recordTypeId: account.record_type_id
                            }))
                          );
                        }}
                        onChange={(data) => {
                          if (data) {
                            const { value, label, recordTypeId } = data;
                            setAccount({ label, value, recordTypeId });
                            if (recordTypeId && value) {
                              getAccount(recordTypeId, value);
                            }
                          } else {
                            setAccount(null);
                            setAccountResponse({});
                          }
                        }}
                        value={
                          account
                            ? {
                                label: account.label,
                                value: account.value
                              }
                            : ''
                        }
                        defaultValue={
                          account
                            ? {
                                label: account.label,
                                value: account.value
                              }
                            : ''
                        }
                        components={{
                          DropdownIndicator: () => (
                            <div
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setIsAccountSearchModalOpen(true);
                              }}
                              style={{
                                padding: '0.6rem',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              <SearchContactButton
                                onClick={() =>
                                  setIsAccountSearchModalOpen(true)
                                }
                                style={{ margin: 0, padding: 0 }}
                              />
                            </div>
                          )
                        }}
                      />
                    </div>
                    <div
                      style={{
                        alignSelf: 'flex-end',
                        justifyContent: 'space-between',
                        padding: '0.6rem',
                        marginLeft: '0.2rem'
                      }}
                    >
                      <Button
                        size="sm"
                        color="info"
                        type="button"
                        title="Editar conta"
                        onClick={handleEditAccount}
                        disabled={!account}
                      >
                        <li className="fas fa-user-edit"></li>
                      </Button>
                    </div>
                    <div
                      style={{
                        alignSelf: 'flex-end',
                        justifyContent: 'space-between',
                        padding: '0.6rem',
                        marginLeft: '-0.5rem'
                      }}
                    >
                      <AddAccountModal
                        onAddedAccount={(data) => {
                          setAccount({
                            label: data.name,
                            value: data.id,
                            recordTypeId: data.record_type_id
                          });
                        }}
                        buttonOpenModal={({ onClick }) => (
                          <AddNewContactButton onClick={onClick} />
                        )}
                      />
                    </div>
                  </div>
                </Col>
                <Col sm="3">
                  <label className="form-control-label text-capitalize">
                    Contato
                  </label>
                  <div style={{ display: 'flex' }}>
                    <div style={{ flexGrow: 1 }}>
                      <SelectContact
                        isClearable
                        allowCreateWhileLoading={false}
                        isValidNewOption={() => false}
                        placeholder="Buscar contato"
                        styles={custom_select}
                        value={selectedClient}
                        options={clientToSelect}
                        onInputChange={seachClientSelect}
                        onChange={setClientSelected}
                        components={{
                          DropdownIndicator: () => (
                            <div
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setIsClientSearchModalOpen(true);
                              }}
                              style={{
                                padding: '0.6rem',
                                cursor: 'pointer',
                                alignItems: 'center'
                              }}
                            >
                              <SearchContactButton
                                onClick={() => setIsClientSearchModalOpen(true)}
                                style={{ margin: 0, padding: 0 }}
                              />
                            </div>
                          )
                        }}
                      />
                    </div>
                    <div
                      style={{
                        alignSelf: 'flex-end',
                        justifyContent: 'space-between',
                        padding: '0.6rem',
                        marginLeft: '0.2rem'
                      }}
                    >
                      <Button
                        size="sm"
                        color="info"
                        type="button"
                        title="Editar contato"
                        onClick={async (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          await handleEditContact();
                          setIsEditContactModalOpen(true);
                        }}
                        disabled={!selectedClient}
                      >
                        <li className="fas fa-user-edit"></li>
                      </Button>
                    </div>
                    <div
                      style={{
                        padding: '0.6rem',
                        marginLeft: '-0.5rem'
                      }}
                    >
                      <AddContactModal
                        defaultFieldsAutoComplete={[
                          {
                            email: 'teste@email.com'
                          }
                        ]}
                        setSelectedContact={alterDefaultModalData}
                        buttonOpenModal={({ onClick }) => (
                          <AddNewContactButton onClick={onClick} />
                        )}
                      />
                    </div>
                  </div>
                </Col>
                <Col sm="3">
                  <label className="form-control-label">Valor</label>
                  <Controller
                    render={(props) => (
                      <CurrencyMask
                        shouldDisable={
                          !recordType || opportunity?.wasCreatedWithProduct
                        }
                        valueController={setValue}
                        value={props.value}
                        fieldName="amount"
                        placeholder="Valor"
                      />
                    )}
                    control={control}
                    defaultValue={0}
                    rules={{ required: 'Campo obrigatório' }}
                    name="amount"
                  />
                  <ErrorMessage
                    errors={errors}
                    name="amount"
                    render={({ message }) => errorFormMessage(message)}
                  />
                </Col>
                <Col sm="3">
                  <label
                    className="form-control-label"
                    style={{ marginTop: '1rem' }}
                  >
                    Previsão de encerramento
                  </label>
                  <Controller
                    render={(props) => (
                      <div>
                        <DatePicker
                          fieldName="expectedClosure"
                          valueController={setValue}
                          defaultValue={props.value}
                        />
                      </div>
                    )}
                    control={control}
                    defaultValue=""
                    name="expectedClosure"
                  />
                  <ErrorMessage
                    errors={errors}
                    name="expectedClosure"
                    render={({ message }) => errorFormMessage(message)}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <CustomFieldsInputsForm
                  fields={filteredCustomFields}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  watch={watch}
                  Controller={Controller}
                  setChatCreatedOnIsolatedMessageId={
                    setChatCreatedOnIsolatedMessageId
                  }
                  setCallUniqueId={setCallUniqueId}
                  isTryingToCreateAContactAttempt={true}
                  isOnEditPage={true}
                  isUpdate={true}
                  options={{
                    showCallIconOnPhoneField: true,
                    showMessageIconOnPhoneField: true
                  }}
                  contactMessageClientName={opportunity?.title}
                />
              </Row>

              {(!recordType || opportunity?.wasCreatedWithProduct) && (
                <>
                  <CatalogProductsForm
                    ref={catalogFormRef}
                    watch={watch}
                    getValues={getValues}
                    control={control}
                    setValue={setValue}
                    isEditing={true}
                    catalogData={opportunityCatalog}
                    setCatalogData={setOpportunityCatalog}
                    proposalId={currentOpportunityStage?.proposalId || null}
                    accountData={accountResponse}
                    contactData={contactResponse}
                  />

                  <Row className="mt-3">
                    <Col>
                      <ShowHistoryChanges
                        data={opportunityCatalogChangeHistory}
                      />
                    </Col>
                  </Row>
                </>
              )}

              {listSchedules ? (
                <ListSchedules
                  listSchedules={listSchedules}
                  handleUpdateSchedule={handleUpdateSchedule}
                  cancelSchedule={cancelSchedule}
                />
              ) : (
                <Row className="justify-content-md-center">
                  <Loader
                    type="TailSpin"
                    color="#35ac50"
                    height={100}
                    width={100}
                  />
                </Row>
              )}
              <ModalSchedulingProtocol
                className="modal-lg"
                show={isSchedulingModalOpen}
                onModalToggle={setIsSchedulingModalOpen}
                schedulingId={schedulingId}
                setschedulingId={setschedulingId}
                isToCreateScheduling={isToCreateScheduling}
                isToUpdateScheduling={isToUpdateScheduling}
                entity={'OPPORTUNITY'}
                entityId={id}
                recordTypeId={recordTypeId}
                getEntityById={getOpportunityById}
                isFromNotification={false}
                isCurrentResponsible={isCurrentResponsible}
              />
              <Col className="text-right">
                <Button
                  title="Adicionar novo agendamento"
                  color="success"
                  type="button"
                  onClick={() => {
                    setIsSchedulingModalOpen(true);
                    setIsToCreateScheduling(true);
                  }}
                >
                  <FiPlus size={16} /> Adicionar agendamento
                </Button>
              </Col>
              {listComments && (
                <ListComments
                  listComments={listComments}
                  reloadComments={reloadComments}
                  handleUpdateComment={handleUpdateComment}
                />
              )}
              <Row style={{ paddingTop: '20px' }}>
                <Col className="text-right">
                  <Button
                    title="Adicionar novo comentário"
                    color="success"
                    type="button"
                    onClick={() => handleCreateComment()}
                  >
                    <FiPlus size={16} /> Adicionar Comentário
                  </Button>
                </Col>
              </Row>

              {opportunityConversations.length > 0 && (
                <>
                  <Row className="mt-4">
                    <Col>
                      <h3 className="form-control-label">
                        Conversas Associadas
                      </h3>
                    </Col>
                  </Row>
                  {opportunityConversations.map((conversation) => (
                    <Card
                      key={conversation._id || conversation.id}
                      className="mb-3"
                    >
                      <CardBody>
                        <Row className="align-items-center">
                          <Col md="10">
                            <div>
                              <strong>Cliente:</strong>{' '}
                              {conversation.cliente?.nome || '-'}
                            </div>
                          </Col>
                          <Col md="2" className="text-right">
                            <ConversationDetails
                              conversationData={conversation}
                              buttonText="Exibir conversa"
                              buttonSize="md"
                              buttonColor="success"
                            />
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  ))}
                </>
              )}

              <Row style={{ paddingTop: '20px', paddingBottom: '40px' }}>
                <Col>
                  <h3 className="form-control-label mt-2">Anexo(s)</h3>
                  <Attachments
                    entityId={opportunity?.id}
                    attachments={opportunity?.attachments}
                    onAdded={(addedAttachments) => {
                      setOpportunity((prev) => ({
                        ...prev,
                        attachments: [...prev.attachments, ...addedAttachments]
                      }));
                    }}
                    onDeleted={(attachmentId) => {
                      const remainAttachments = opportunity.attachments.filter(
                        (att) => att.id !== attachmentId
                      );
                      setOpportunity((prev) => ({
                        ...prev,
                        attachments: remainAttachments
                      }));
                    }}
                    entityService={OpportunityService}
                  />
                </Col>
              </Row>
              <Row
                style={{
                  paddingTop: '20px',
                  paddingBottom: '20px',
                  backgroundColor: 'rgb(238 239 242)',
                  border: '1px solid rgb(233 233 233)',
                  borderRadius: '0.1rem',
                  marginLeft: '0.1rem',
                  marginRight: '0.1rem'
                }}
              >
                <Col sm="12" className="d-flex justify-content-between mb-3">
                  <h3 className="mb-0">
                    Endereço ({opportunityAddresses?.length || 0})
                  </h3>
                  <AddAddressModal
                    entityType="opportunity"
                    entityId={id}
                    entity={opportunity}
                    onAddedAddress={reloadOpportunity}
                    buttonOpenModal={({ onClick }) => (
                      <Button
                        title="Adicionar endereço"
                        color="success"
                        size="sm"
                        type="button"
                        onClick={onClick}
                      >
                        <FiPlus size={16} /> Adicionar Endereço
                      </Button>
                    )}
                  />
                </Col>
                <Col sm="12">
                  <OpportunityAddress
                    addresses={opportunityAddresses}
                    opportunityId={id}
                    reloadOpportunity={reloadOpportunity}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="text-left">
                  <ReactButton btnColor="confirmation" type="submit">
                    Salvar
                  </ReactButton>

                  <ReactButton
                    btnColor="cancelation"
                    onClick={() => {
                      return cancelAction();
                    }}
                  >
                    Cancelar
                  </ReactButton>
                </Col>
                <Col className="text-right">
                  <Button
                    color="primary"
                    type="button"
                    onClick={() => openContactAttemptTimeline()}
                  >
                    <i className="fas fa-history" /> Histórico de Tentativas de
                    Contato
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </Container>

      <ChangeResponsibleModal
        isModalOpen={isChangeReponsibleModalOpen}
        onModalToggle={setIsChangeReponsibleModalOpen}
        opportunityId={opportunity?.id}
        callback={getOpportunityById}
      />
      <CommentModal
        render={getCommnents}
        opportunityId={id}
        isModalOpen={openModalCreateComment}
        onModalToggle={setOpenModalCreateComment}
        unmountOnClose={true}
      />

      <ConversionModal
        opportunityId={id}
        isModalOpen={openConversionOpportunityModal}
        onModalToggle={setOpenConversionOpportunityModal}
        unmountOnClose={true}
        activeStage={activeStage}
        opportunity={opportunity}
        recordTypeId={recordTypeId}
      />

      <ModalComment
        render={getCommnents}
        dataComment={dataCommentUpdate}
        isModalOpen={openModalUpdateComment}
        onModalToggle={setOpenModalUpdateComment}
        unmountOnClose={true}
      />
      {id && (
        <ContactAttemptTimelineModal
          entityId={id}
          entityType="OPPORTUNITY"
          isModalOpen={isContactAttemptTimelineModalOpen}
          onModalToggle={setIsContactAttemptTimelineModalOpen}
        />
      )}
      <OpportunityTimeModal
        opportunityId={id}
        isModalOpen={openModalOpportunityTime}
        onModalToggle={setOpenModalOpportunityTime}
        unmountOnClose={true}
        changedStage={changedStage}
        setChangedStage={setChangedStage}
      />
      <ModalFilterClients
        className="modal-lg"
        show={isAccountSearchModalOpen}
        onModalToggle={setIsAccountSearchModalOpen}
        setSelectedClient={(account) => {
          setAccount({
            value: account?.clientId,
            label: account?.clientName,
            recordTypeId: account?.accountRecordTypeId
          });
          setIsAccountSearchModalOpen(false);
        }}
        account={true}
        recordTypes={[]}
        customFields={[]}
      />

      <EditAccountModal
        isModalOpen={isEditAccountModalOpen}
        onModalToggle={(isOpen) => {
          setIsEditAccountModalOpen(isOpen);
          if (!isOpen && account?.recordTypeId && account?.value) {
            getAccount(account.recordTypeId, account.value);
          }
        }}
        account={accountResponse}
        recordTypeId={account?.recordTypeId}
        setSelectedClient={(account) => {
          setAccount({
            value: account?.clientId,
            label: account?.clientName,
            recordTypeId: account?.accountRecordTypeId
          });
          if (account?.accountRecordTypeId && account?.clientId) {
            getAccount(account.accountRecordTypeId, account.clientId);
          }
        }}
      />
    </>
  );
};

export default OpportunityEdit;
